<template>
	<section
		v-editable="blok"
		:class="blok.orangeVariant && 'bg-brand-globus-orange-light text-body-primary'"
		class="sm:py-10"
		:aria-label="blok.title"
	>
		<div class="container">
			<h2 class="typo-h1 mb-4 md:mb-6">
				{{ blok.title }}
			</h2>
			<RichText class="font-primary typo-body-xl" :data="blok.text" />
			<div
				class="flex md:justify-center md:gap-4 lg:gap-14 mt-4 md:mt-8 xl:pr-20 xl:pl-20 max-md:flex-col md:flex-wrap max-md:pt-4 relative overflow-hidden transition-[max-height] duration-700 ease-in-out"
				:class="!isExpanded ? 'max-md:max-h-[23rem]' : 'max-md:max-h-[500rem]'"
			>
				<StoryblokComponent
					v-for="item in blok.children"
					:key="item._uid"
					:blok="item"
					:class="blok.orangeVariant && 'bg-background-highlighted'"
				/>
				<div v-if="blok.cta?.length" class="flex justify-center md:hidden my-4 gap-2 flex-wrap">
					<StoryblokComponent
						v-for="item in blok.cta"
						:key="item._uid"
						:blok="item"
						class="btn btn-primary btn-lg shadow-sm text-center"
					/>
				</div>
				<Transition name="fade">
					<div
						v-if="!isExpanded"
						class="md:hidden absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-background-primary to-transparent pointer-events-none"
					/>
				</Transition>
			</div>
			<div
				class="md:hidden flex justify-center relative after:border-[.0625rem] after:border-neutral-500 after:absolute after:inset-x-0 after:bottom-2.5 after:z-1"
			>
				<button
					type="button"
					class="flex items-center gap-2 px-2 bg-white z-10 relative"
					@click="toggleExpanded()"
				>
					{{ !isExpanded ? 'Zobrazit více' : 'Zobrazit méně' }}
					<NuxtIcon
						name="chevron-down"
						class="text-2xl text-icon-primary transition-transform duration-300"
						:class="{'rotate-180': isExpanded}"
						aria-hidden="true"
						filled
					/>
				</button>
			</div>
			<div v-if="blok.cta" class="flex justify-center mt-4">
				<StoryblokComponent
					v-for="item in blok.cta"
					:key="item._uid"
					:blok="item"
					class="btn btn-primary btn-lg mb-8 md:mb-0 hidden md:inline-flex"
				/>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
	import type {BenefitsPresentationStoryblok} from '@/storyblok/types';

	interface Props {
		blok: BenefitsPresentationStoryblok
	}

	defineProps<Props>();

	const [isExpanded, toggleExpanded] = useToggle(false);
</script>
